module.exports = __webpack_public_path__ + "img/ic_empty.c2882225.png";